export class TipModel {
  name: string;
  value: number;
}

export class TooltipBlockModel {
  pointName: string;
  tips: TipModel[] = [];
}